import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Container } from "./Container";
import { Logo } from "../common/Logo";

const columnHeadingClass =
  "font-heading text-xs font-bold uppercase tracking-[0.15em] text-white/50";
const linkClass = "text-sm text-white/70 transition hover:text-white";

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-footerbody text-white/70">
      <Container>
        <div className="grid gap-10 py-14 sm:grid-cols-[1.5fr_1fr]">
          {/* Brand */}
          <div className="max-w-sm">
            <Logo variant="footer" />
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              {t("Footer.blurb")}
            </p>
          </div>

          {/* Platform */}
          <div>
            <h3 className={columnHeadingClass}>{t("Footer.platform")}</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/merchants" className={linkClass}>
                  {t("Footer.verified-merchants")}
                </Link>
              </li>
              <li>
                <Link to="/services" className={linkClass}>
                  {t("Footer.service-catalog")}
                </Link>
              </li>
              <li>
                <Link to="/about" className={linkClass}>
                  {t("Footer.how-verification-works")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Container>

      {/* Bottom bar */}
      <div className="bg-footerbar text-white">
        <Container>
          <div className="py-3 text-sm">
            <p>{t("Footer.rights", { year })}</p>
          </div>
        </Container>
      </div>
    </footer>
  );
};
